import axiosInstance from "../api/axios";
import { useAppDispatch } from "../store/store";
import { setSubscriptionsList } from "../store/slices/subscriptions.slice";
import { loadStripe } from "@stripe/stripe-js";

import useAccount from "./useAccount";

const useSubscriptions = () => {
  const dispatch = useAppDispatch();
  const { getAccountDetails } = useAccount();

  const getSubscriptions = async () => {
    const response = await axiosInstance.get("/commercials/products/");
    dispatch(setSubscriptionsList(response.data?.results));
  };

  const subscribe = async (id: number) => {
    const response = await axiosInstance.post("/commercials/subscription/", {
      product_id: id,
    });

    const stripe = await loadStripe(response.data.public_key);
    await stripe?.redirectToCheckout({ sessionId: response.data.session_id });
  };

  const cancelSubscribe = async (data: any) => {
    const latestSub = data?.subscriptions.reduce((latest: any, current: any) => {
      const latestDate = new Date(latest.next_pay_at).getTime();
      const currentDate = new Date(current.next_pay_at).getTime();
      return currentDate > latestDate ? current : latest;
    });

    await axiosInstance.post("/commercials/subscription/cancel/", {
      subscription_id: latestSub.stripe_subscription_id,
    });
    await getAccountDetails();
  };
  return {
    getSubscriptions,
    cancelSubscribe,
    subscribe,
  };
};

export default useSubscriptions;
